/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectsControllerBulkCreateMutationRequest, ProjectsControllerBulkCreateMutationResponse, ProjectsControllerBulkCreate400, ProjectsControllerBulkCreate401 } from "../../models/projectsController/ProjectsControllerBulkCreate";

function getProjectsControllerBulkCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/projects/bulk` as const }  
  return res
}

/**
 * @description Create multiple projects in a single call. Supports partial success - if some items fail, the successful ones are still created. Returns 200 if all items succeed, 207 Multi-Status if some items fail. Returns 403 with no projects created when the batch would exceed the organization's plan project limit.
 * @summary Bulk create projects
 * {@link /api/v1/projects/bulk}
 */
export async function projectsControllerBulkCreate(data: ProjectsControllerBulkCreateMutationRequest, config: Partial<RequestConfig<ProjectsControllerBulkCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ProjectsControllerBulkCreateMutationResponse, ResponseErrorConfig<ProjectsControllerBulkCreate400 | ProjectsControllerBulkCreate401>, ProjectsControllerBulkCreateMutationRequest>({ method : "POST", url : getProjectsControllerBulkCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}